import styled from "@emotion/styled";
import { Card, Stack } from "react-bootstrap";
import { DEFAULT_CARD_STYLES } from "../../../shared/styles/Card.styles";
import { IStyledComponentProps } from "../../../theme/theme.types";

const ProjectCard = styled(Card)<IStyledComponentProps>`
  &.project-card {
    ${DEFAULT_CARD_STYLES}
    margin-bottom: 0px;
    height: 100%;
  }
  .envelope-icon {
    font-size: 16px;
    color: ${({ theme }) => theme.colors?.brand.secondary};
    margin: 4px 4px 0px;
  }
`;

const ProjectCardHeader = styled(Card.Header)<IStyledComponentProps>`
  &.project-card-header {
    background-color: ${({ theme }) => theme.colors?.essential.white};
    border-radius: 0;
    min-height: 98px;
    display: flex;
    align-items: center;

    :hover {
      background-color: ${({ theme }) => theme.colors?.essential.grayLight};
      cursor: pointer;
    }

    h4 {
      color: ${({ theme }) => theme.colors?.cta.primary};
      margin: 12px 0;
    }
  }
`;

const ProjectCardBody = styled(Card.Body)<IStyledComponentProps>`
  &.project-card-body {
    padding: 0 0 0 0;
    overflow: hidden;
  }
`;

const ProjectCardFooter = styled(Card.Footer)<IStyledComponentProps>`
  &.project-card-footer {
    background-color: ${({ theme }) => theme.colors?.essential.white};
    .ce-CSSO-button {
      border-color: ${({ theme }) => theme.colors?.brand.secondary} !important;
      color: ${({ theme }) => theme.colors?.brand.secondary} !important;
      width: 100%;
    }

    .ce-CSSO-button:hover {
      background-color: ${({ theme }) => theme.colors?.grays.quaternary};
    }
  }
`;

const ProjectDetailsStack = styled(Stack)<IStyledComponentProps>`
  &.project-details-stack {
    padding: 1rem;
  }
`;

const PackageListContainer = styled.div<IStyledComponentProps>`
  &.package-list-container {
    background-color: ${({ theme }) => theme.colors?.essential.grayLight};
    box-shadow: inset 0 3px 6px -6px black;
    padding: 1rem;

    &.desktop {
      height: 350px;
    }

    &.mobile {
      height: max-content;
    }

    .package-list-label {
      display: block;
      font-family: ${({ theme }) => theme.fontFamilies.semiBold};
      margin-bottom: 8px;
    }
  }
`;

const DetailsStackItem = styled.div<IStyledComponentProps>`
  &.details-stack-item {
    font-size: ${({ theme }) => theme.fontSizes?.base}px;
    min-height: 48px;

    .details-stack-item-label {
      font-family: ${({ theme }) => theme.fontFamilies.semiBold};
    }
    .details-stack-email {
      color: ${({ theme }) => theme.colors?.brand.secondary};
      text-decoration-line: none;
    }
  }
`;

export default {
  ProjectCard,
  ProjectCardHeader,
  ProjectCardBody,
  ProjectDetailsStack,
  PackageListContainer,
  ProjectCardFooter,
  DetailsStackItem,
};
